
<template>
  <div class="process">
    <img :src="interFlowImage" />
  </div>
</template>

<script>
export default {
  name: "IntoProcess",
  props: ["interFlowImage"],
};
</script>

<style scoped>
.process {
  text-align: center;
  padding-top: 50px;
}
</style>
